import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { PlantService } from '../../../services/plant.service';
import { Plant } from '../../../models/plant.model';

@Component({
  selector: 'app-factories-tab',
  templateUrl: './factories-tab.component.html',
  standalone: false,
})
export class FactoriesTabComponent implements OnInit {
  plants: Plant[] = [];
  selectedPlant: Plant | null = null;
  editDescription: string = '';
  isLoading = false;
  isSaving = false;

  constructor(
    private plantService: PlantService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.loadPlants();
  }

  private loadPlants(): void {
    this.isLoading = true;
    this.plantService.getAll().subscribe({
      next: (plants) => {
        this.plants = plants;
        this.isLoading = false;
      },
      error: () => {
        this.messageService.add({
          key: 'globalToast',
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de charger les usines.',
          life: 4000,
        });
        this.isLoading = false;
      },
    });
  }

  onPlantSelect(): void {
    this.editDescription = this.selectedPlant?.Description ?? '';
  }

  save(): void {
    if (!this.selectedPlant) return;
    this.isSaving = true;
    this.plantService
      .updateDescription(
        this.selectedPlant.SapPlantId,
        this.editDescription || null,
      )
      .subscribe({
        next: (updated) => {
          const idx = this.plants.findIndex(
            (p) => p.SapPlantId === updated.SapPlantId,
          );
          if (idx !== -1) this.plants[idx] = updated;
          this.selectedPlant = updated;
          this.messageService.add({
            key: 'globalToast',
            severity: 'success',
            summary: 'Sauvegardé',
            detail: `Description de l'usine ${updated.SapPlantId} mise à jour.`,
            life: 3000,
          });
          this.isSaving = false;
        },
        error: () => {
          this.messageService.add({
            key: 'globalToast',
            severity: 'error',
            summary: 'Erreur',
            detail: 'Impossible de mettre à jour la description.',
            life: 4000,
          });
          this.isSaving = false;
        },
      });
  }
}
